import React from "react";
import styled from "styled-components";

const BG_MAIN = '#0054C5'
const HEIGHT_MAIN = '60px'
const COLOR_MAIN = '#0054C5'

const RefreshContainer= styled.div`
  height: 100%;
  overflow: auto;
`;

const PullIndicatorStyle = styled.div`
   
    position: relative;
    z-index: 1000;  /* Set z-index to a high value */
    /* display: flex !important; */
    align-items: center;
    justify-content: center;
    background: ${BG_MAIN};
    /* display: none; */
    /* display: none; */
    .pull-indicator-box {
      height: ${HEIGHT_MAIN};
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .loader {
      zoom: 0.7;
      width: 15px;
      height: 15px;
      margin-left: 15px;
      background: ${COLOR_MAIN};
      display: inline-block;
      position: relative;
      box-sizing: border-box;
      animation: bump 0.4s ease-in infinite alternate;
    }
    .loader::after {
      content: '';  
      box-sizing: border-box;
      left: 50%;
      top: 100%;
      transform: translate(-50%, 0);
      position: absolute;
      border: 15px solid transparent;
      border-top-color: ${COLOR_MAIN};
    }

    @keyframes bump {
      0% {
        transform: translate(-50%, 5px);
      }
      100% {
        transform: translate(-50%, -5px);
      }
    }
    
`;

function PullIndicator(props) {
  // return (
  //   <PullIndicatorStyle {...props} id="pull-indicator" >↓ Pull to refresh</PullIndicatorStyle>
  // );
  return (
    <PullIndicatorStyle {...props} id="pull-indicator" >
      <div className="pull-indicator-box">
        <img className="imgPreload" src="assets/img/ui/ico-preload.svg" height={60} alt=""/>
        {/* <div class="loader"></div> 
        <div style={{ color: COLOR_MAIN, fontWeight: 700, textTransform: 'uppercase', marginLeft: '8px' }}> Pull to refresh</div> */}
      </div>
    </PullIndicatorStyle>
  );
}


const Reloading = styled.div`
  position: relative;
  z-index: 1000;  /* Set z-index to a high value */
  height: ${HEIGHT_MAIN};
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${BG_MAIN};

  .loader {
    zoom: 0.6;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    display: block;
    margin: 15px auto;
    position: relative;
    background: #fff;
    box-shadow: -24px 0 #fff, 24px 0 #fff;
    box-sizing: border-box;
    animation: shadowPulse 1500ms linear infinite;
  }

  @keyframes shadowPulse {
    33% {
      background: #fff;
      box-shadow: -24px 0 ${COLOR_MAIN}, 24px 0 #fff;
    }
    66% {
      background: ${COLOR_MAIN};
      box-shadow: -24px 0 #fff, 24px 0 #fff;
    }
    100% {
      background: #fff;
      box-shadow: -24px 0 #fff, 24px 0 ${COLOR_MAIN};
    }
  }
`;

function DefaultRefreshIcon() {
  return (
    <Reloading>
      <div class="loader"></div>
    </Reloading>
  );
}

export { RefreshContainer, PullIndicator, DefaultRefreshIcon };